import React, { useEffect, useState, useRef } from 'react';
import { makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import axios from 'axios';
// import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
// import FormDialog from '../../../../components/table/FormDialog';
import { CommonConfig } from '../../../../config/common-config';
import token from '../../../../config/token';
import ServiceLayout from '../../../invoices/common/serviceLayout';
import ServiceTableClient from '../Table/tableclient';
import '../../servicestyles.css';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        // marginTop: theme.spacing(6),
    },
    container: {
        marginBottom: theme.spacing(1),
    },
    paper: {
        marginBottom: theme.spacing(1),
    },
    noRecord: {
        display: 'flex',
        justifyContent: 'center',
        background: '#f6f6f6',
        margin: '16px',
        '& h1': {
            alignSelf: 'center',
            color: 'grey',
            fontFamily: 'Rubik',
            fontSize: '14px',
            fontWeight: '400',
        },
    },
}));

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const OpenServiceClient = (props) => {
    const tokens = token();
    const classes = useStyles();
    const myRef = useRef();
    const [searchQuery, setSearchQuery] = useState('');
    const [ultimateRows, setUltimateOpenService] = useState([]);
    const [AllImcs, setAllImcs] = useState([]);
    const [selectedImc, setselectedImc] = useState('');
    const [openBox, setOpenBox] = useState(false);
    // const [deleteMsg, setDeleteMsg] = useState('');
    const vertical = 'top';
    const horizontal = 'center';
    // const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    // const dbname = tennantDetails.tennantName;
    //console.log("dbname", dbname);

    // Token Generation

    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;

    const tennantname = useSelector((state) => state.loginsuccessreducer.tennantName);
    const tennantnameValue = tennantname && tennantname.tennantName;

    const [page, setPage] = useState(0);
    const [pageDetails, setPageDetails] = useState('');
    const [loading, setLoading] = useState(false);
    const [previousButton, setpreviousButton] = useState(false);
    const [nextButton, setnextButton] = useState(false);

    //console.log("tennatName" , tennantnameValue)
    // Headcells

    const scrollTop = () => {
        myRef.current.scrollIntoView();
    };
    const headcells = [
        { id: 'serviceId', label: 'Service ID' },
        // { id: 'clientId', label: 'Client id' },
        // { id: 'clientName', label: 'Client name' },
        // { id: 'clientType', label: 'Client type' },
        { id: 'description', label: 'Description' },
        { id: 'servicetypeId', label: 'Service type', isConcat: 'true', concatElem: ['servicetypeText'] },
        { id: 'serviceYear', label: 'Year' },
        { id: 'startDate', label: 'Start date' },
        { id: 'statusId', label: 'Current status' },
    ];

    // const history = useHistory();

    // to set the Rows by default
    const getCandidates = () => {
        setLoading(true);
        setpreviousButton(true);
        setnextButton(true);
        const bearerToken = `Bearer ${userToken}`;
        axios
            .get(
                `${CommonConfig.dev.baseUrl}/api/auth/getservice-byemployeeid/${tennantnameValue}?page=${page}&size=10&sort=serviceId,desc`,
                tokens
            )
            .then((response) => {
                //console.log("response", response.data);
                formatDate(response.data.content);
                scrollTop();
                setUltimateOpenService(response.data.content);
                setPageDetails(response.data);
                setLoading(false);
                if (response.data.first) {
                    setpreviousButton(true);
                    setnextButton(false);
                } else if (response.data.last) {
                    setpreviousButton(false);
                    setnextButton(true);
                } else {
                    setpreviousButton(false);
                    setnextButton(false);
                }
            })
            .catch((error) => {
                //console.log(error);
            });
    };

    useEffect(() => {
        // axios
        //     .get(`${CommonConfig.dev.baseUrl}/api/auth/s-int-clients`)
        //     .then((response) => setAllImcs(response.data.content))
        //     .catch((error) => {
        //         //console.log(error);
        //     });
        getCandidates();
        //console.log('PAGE NO : ', page);
    }, [userToken, page, tokens]);

    const handleCount = (val) => {
        if (val === 'prev') {
            if (!pageDetails.first) {
                setPage((page) => page - 1);
            }
        }

        if (val === 'next') {
            if (!pageDetails.last) {
                setPage((page) => page + 1);
            }
        }
    };

    // const setImc = (e) => {
    //     setselectedImc(e.target.value);
    //     axios
    //         .get(`${CommonConfig.dev.baseUrl}/api/auth/getservice-byemployeeid/${e.target.value}?page=0&size=1000&sort=serviceId,desc`)
    //         .then((response) => {
    //             setUltimateOpenService(response.data.content);
    //             //console.log("TEST",response.data.content);
    //         })
    //         .catch((error) => {
    //             //console.log(error.response.data);
    //             // if (error.response.data) {
    //             //     setTotalReactPackages([]);
    //             // }
    //         });
    // };

    // const allImcsOptions = (vv) => {
    //     const OptionList = vv.map((data) => (
    //         <option value={data.dbName} key={data.dbName}>
    //             {data.dbName}
    //         </option>
    //     ));
    //     return OptionList;
    // };
    // const handleClose = () => {
    //     setOpenBox(false);
    // };

    // handleClickonParticularRow

    const handleClickRow = () => {
        //console.log('Click on Particular Row');
    };
    // Delete Row

    // const handleDelete = (row, data) => {
    //     //console.log('deleted Row', row);
    //     //console.log('comments Row', data);

    //     if (row.serviceId) {
    //         axios
    //             .delete(`${CommonConfig.dev.baseUrl}/api/auth/createservice-employee/${selectedImc}/${row.serviceId}`, { data })
    //             .then((response) => {
    //                 //console.log("response", response.data);
    //                 setDeleteService(response.data);
    //                 props.history.push('/menu/closedservice');
    //                 setDeleteMsg('record successfully deleted');
    //                 setOpenBox(true);
    //             })
    //             .catch((error) => {
    //                 if (error) {
    //                     // setShowBtnLoader(false);
    //                     const err = error.response.data;
    //                     //console.log('error:', err);
    //                     // setErrormsg(err.message);
    //                 }
    //             });
    //     }
    // };

    function formatDate(props) {
        return props.map((element) => {
            if (element.startDate) {
                const tempStartDate = element.startDate;
                const pattern = /(\d{2})\-(\d{2})\-(\d{4})/;
                const formatDate = new Date(tempStartDate.replace(pattern, '$3-$2-$1'));
                element.startDate = moment(formatDate).format('DD-MM-YYYY');
            } else {
                return false;
            }
        });
    }

    // search Query
    const handleSearchQuery = (searchData) => {
        //console.log(searchData);
        setSearchQuery(searchData);
    };

    // Search through nested objects
    const filteredRow = searchQuery
        ? ultimateRows.filter((searchRow) => {
            const query = searchQuery.toLowerCase().trim();
            //   ////console.log(Object.keys(row) ,"Keys of ROW**** object.keys()");
            return headcells
                .map((col) => col)
                .some((key) => {
                    if (key.isConcat && searchRow[key.id]) {
                        const subdata = searchRow[key.id];
                        const mergedData = key.concatElem.map((concatdata) => {
                            return concatdata.split('.').reduce((acc, item) => {
                                if (Object.prototype.hasOwnProperty.call(acc, item)) {
                                    if (typeof acc[item] !== 'object') {
                                        return acc[item].toString().toLowerCase().includes(query);
                                    }
                                    return acc[item];
                                }
                                return false;
                            }, subdata);
                        });
                        return mergedData[0];
                    }
                    if (searchRow && searchRow[key.id]) {
                        //   ////console.log('searchRow[key.id]',searchRow[key.id])
                        //   ////console.log('toString().toLowerCase()',searchRow[key.id].toString().toLowerCase())
                        return searchRow[key.id].toString().toLowerCase().includes(query);
                    } else {
                        return false;
                    }
                });
        })
        : ultimateRows;

    return (
        <>
            <div className={classes.root} ref={myRef}>
                {/* <div className="itec-textboxes">
                    Select IMC
                    <select className="intclientName intSelect" name="intclientName" onChange={setImc} value={selectedImc}>
                        <option value="" selected disabled hidden>
                            Select IMC
                        </option>
                        {allImcsOptions(AllImcs)}
                    </select>
                </div> */}

                <ServiceLayout
                    title="Open Services"
                    searchQuery={searchQuery}
                    onChange={handleSearchQuery}
                    className={classes}
                    service="ultimateopen"
                >
                    {filteredRow.length > 0 ? (
                        <>
                            <ServiceTableClient
                                headcells={headcells}
                                rows={filteredRow}
                                pageName="ultimateservice"
                                service="ultimateopen"
                                handleClickRow={handleClickRow}
                                handleCount={handleCount}
                                pageDetails={pageDetails}
                                loading={loading}
                                prvnxtbt={{ prvBt: previousButton, nxtBt: nextButton }}
                            />
                        </>
                    ) : (
                            <div className={classes.noRecord}>
                                <h1>No records to display</h1>
                            </div>
                        )}

                    {/* {filteredRow.length === 0 && <span style={{ fontSize: '14px', fontWeight: '700' }}>No records found to display!</span>}
                    <ServiceTableClient
                        headcells={headcells}
                        rows={filteredRow}
                        pageName="ultimateservice"
                        service="ultimateopen"
                        handleClickRow={handleClickRow}
                    /> */}
                </ServiceLayout>
            </div>
        </>
    );
};

export default OpenServiceClient;
